import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostTriggerBulkPreviewChecksBodySchema,
  TPostTriggerBulkPreviewChecksResponseSchema,
} from "./postTriggerBulkPreviewChecks.schema";

export const postTriggerBulkPreviewChecks = (axios: IAxiosInstance) => {
  return async (body: TPostTriggerBulkPreviewChecksBodySchema) => {
    const response = await axios.noRetry.post<
      ZealApiResponse<TPostTriggerBulkPreviewChecksResponseSchema>
    >("/api/triggerBulkPreviewChecks", body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
